import React from "react";
import QRCode from "react-qr-code";
import { generateQRStringFromOrder } from "../../../utils/nbsQRGenerator";

interface NBSQRCodeProps {
  order: any;
}

const NBSQRCode: React.FC<NBSQRCodeProps> = ({ order }) => {
  const { qrString, validation } = generateQRStringFromOrder(order);

  // Check if this is a volunteer delivery order
  const isVolunteerDelivery =
    order.userDeliveryResponse &&
    (order.deliveryType === "FAST_DELIVERY" ||
      order.deliveryType === "STANDARD_DELIVERY" ||
      order.deliveryType === "PENSION_CARD_DELIVERY");

  // Don't show QR for non-volunteer delivery orders
  if (!isVolunteerDelivery) {
    return (
      <div
        style={{
          padding: "15px",
          border: "1px dashed #999",
          textAlign: "center",
          color: "#666",
          fontSize: "12px",
        }}
      >
        <p>QR kod nije dostupan</p>
        <p>• Dostupan samo za volontirane dostave</p>
      </div>
    );
  }

  if (!validation.canGenerateQR) {
    return (
      <div
        style={{
          padding: "15px",
          border: "1px dashed #999",
          textAlign: "center",
          color: "#666",
          fontSize: "12px",
        }}
      >
        <p>
          <strong>QR kod nije dostupan</strong>
        </p>
        {validation.errors.map((error, index) => (
          <p key={index} style={{ margin: "5px 0", fontSize: "11px" }}>
            • {error}
          </p>
        ))}
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", margin: "15px 0" }}>
      <div
        style={{ marginBottom: "8px", fontSize: "14px", fontWeight: "bold" }}
      >
        NBS IPS QR
      </div>
      <div
        style={{
          padding: "8px",
          backgroundColor: "white",
          border: "1px solid #ddd",
          display: "inline-block",
        }}
      >
        <QRCode value={qrString!} size={120} level="M" />
      </div>
    </div>
  );
};

export default NBSQRCode;
